export function formatBDT(amount) {
  if (amount == null || isNaN(amount)) return "৳0";

  return (
    "৳" +
    new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 0,
    }).format(amount)
  );
}
